import { useTheme } from '@/hooks/useTheme';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import type { ThemeMode } from '@/types/common';

const themeOptions: { value: ThemeMode; label: string; icon: string }[] = [
  { value: 'light', label: 'Light', icon: 'fas fa-sun' },
  { value: 'dark', label: 'Dark', icon: 'fas fa-moon' },
  { value: 'system', label: 'System', icon: 'fas fa-desktop' }
];

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const currentIcon = themeOptions.find(option => option.value === theme)?.icon || themeOptions[0].icon;

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-primary-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:text-primary-400 dark:hover:bg-dark-bg/50">
        <i className={`fas ${theme === 'dark' ? 'fa-moon' : theme === 'light' ? 'fa-sun' : 'fa-desktop'} w-5 h-5`} />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 w-36 origin-top-right rounded-lg bg-gray-900/90 backdrop-blur-sm shadow-lg ring-1 ring-white/10 focus:outline-none">
          <div className="py-1">
            {themeOptions.map((option) => (
              <Menu.Item key={option.value}>
                {({ active }) => (
                  <button
                    onClick={() => setTheme(option.value)}
                    className={`
                      ${active ? 'bg-gray-800/50' : ''}
                      ${theme === option.value ? 'text-primary-400' : 'text-gray-300 hover:text-white'}
                      group flex w-full items-center px-4 py-2 text-sm transition-colors duration-150
                    `}
                  >
                    <i className={`${option.icon} w-5 mr-3`} />
                    {option.label}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}